<template>
  <div class="w-full flex gap-2" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ label }}</div>
    <div class="flex-1" :class="size" >
      <vs-select class="w-full" autocomplete v-model="select" @change="change" :disabled="readonly">
        <vs-select-item v-for="(item, index) in list" :key="index" :text="item.text || item.value" :value="item.value" />
      </vs-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchNavItemSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: [Number, String],
    list: Array,
    size: {
      type: String,
      default: "normal",
    },
    readonly: Boolean,
    widthClass: String,
    name: {
      type: String,
      default: "searchType",
    }
  },
  watch: {
    value(value) {
      this.select = value;
    },
    list: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.value) {
          if (typeof this.list === "object" && this.list.length > 0) {
            this.select = this.list[0].value;
          }
          if (typeof this.list === "number") {
            //this.select = this.list
          }
          this.change(this.select);
        }
      },
    },
  },
  computed: {
    getSearchType () {
      const query = this.$route.query;
      if (query[this.name]) {
        try {
          return query[this.name]
        } catch (e) {}
      }
      return this.select
    },
  },
  data() {
    return {
      select: this.value,
    };
  },
  created() {
    this.select = this.getSearchType
    this.change(this.select);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="scss" scoped>
div.small {
  width: 114px;
}

.title {
  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 114px !important;
  }
}
</style>
